export default "__VITE_ASSET__DxN30F5g__"